import { Action } from '../../../common/actions/core/action';

export class OtpExpireAction implements Action {
  constructor() { }
}


// WEBPACK FOOTER //
// src/app/no-auth/components/otp-expire-dialog/otp-expire-dialog.action.ts